module.exports = __webpack_public_path__ + "static/media/services-submenu-main-health.13f7d2e4.png";